// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';
import { applyAspectRatioBoxStyles } from '@tcp/core/src/utils';

const isAnimationModule = true;
const isBackground = false;

export const StyleIconBlock = styled.div`
  position: absolute;
  bottom: 16px;
  left: 16px;

  ${(props) =>
    !props.isHalfWidthModule
      ? `@media ${props.theme.mediaQuery.smallOnly} {
    bottom: 24px;
    left: 2px;
  }`
      : ``};

  .image_animation_play_pause_button {
    background: transparent;
    border: 0;
    cursor: pointer;
  }
`;

export const StyledImageContainer = styled.div`
  overflow: hidden;
  height: 0;
  position: relative;
  ${(props) =>
    applyAspectRatioBoxStyles(
      props.aspectRatioObj,
      'MOBILE',
      isBackground,
      isAnimationModule,
      props.isHalfWidthModule
    )}
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) =>
      applyAspectRatioBoxStyles(
        props.aspectRatioObj,
        'TABLET',
        isBackground,
        isAnimationModule,
        props.isHalfWidthModule
      )}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) =>
      applyAspectRatioBoxStyles(
        props.aspectRatioObj,
        'DESKTOP',
        isBackground,
        isAnimationModule,
        props.isHalfWidthModule
      )}
  }
`;

export const StyledImageBlock = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  will-change: transform;
  display: flex;
  img {
    width: 100%;
    height: 100%;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      min-width: ${(props) => (props.isHalfWidthModule ? `360px` : `390px`)};
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      min-width: ${(props) => (props.isHalfWidthModule ? `360px` : `1410px`)};
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      min-width: ${(props) => (props.isHalfWidthModule ? `600px` : `1410px`)};
    }
  }
`;
